{
  "currency-symbol": "$",
  "data-refresh": {
    "availability": {
      "label": "When are you available to start?",
      "now": "Available Now",
      "specific-date": "Available on a Specific Date",
      "specific-date-placeholder": "Availability date",
      "with-notice": "Available with notice",
      "with-notice-placeholder": "Enter the number of weeks notice"
    },
    "check-in": "When can we check in with you again?",
    "employment-type": {
      "label": "Work Type*",
      "temp": "Temp",
      "temp-to-perm": "Temp-to-perm",
      "perm": "Permanent",
      "error": "Please select at least one of permanent, temp, or temp-to-perm"
    },
    "error": {
      "required": "{{fieldName}} is a required field",
      "at-least-one": "At least one option must be selected",
      "at-least-one-groups": "At least one option from each group must be selected"
    },
    "header": {
      "text": "Update your job preferences",
      "subtext-required": "All fields are required"
    },
    "hourly-rate": {
      "label": "Hourly Rate{{required}}",
      "target": "Target",
      "minimum": "Minimum",
      "per-hour":"/hr",
      "error-minimum": "Please enter a value into minimum hourly rate",
      "error-target": "Please enter a value into target hourly rate",
      "error-both": "Please enter a value  into minimum and target hourly rate"
    },
    "hours": {
      "label": "Hours",
      "full-time": "Full Time",
      "part-time": "Part Time",
      "error": "Please select at least one of full time or part time"
    },
    "last-updated": "Last updated on {{lastUpdated}}",
    "location": "Where are you located?",
    "opportunities": "Are you considering new opportunities?",
    "read-only": {
      "header": "Timing is everything",
      "subtext": "Right now is prime time to get you in the mix for some amazing job opportunities. We're checking in to make certain we're accurately representing your preferences. Please confirm the following information is correct:",
      "minimum-hourly": "Minimum hourly rate:",
      "target-hourly": "Target hourly rate:",
      "minimum-salary": "Minimum salary:",
      "target-salary": "Desired salary:",
      "preferred-work-type": "Preferred work type:",
      "preferred-hours": "Preferred hours:",
      "preferred-workplace": "Preferred workplace:",
      "looks-good": "Looks Good",
      "edit": "Edit"
    },
    "salary": {
      "label": "Yearly Salary{{required}}",
      "target": "Target",
      "minimum": "Minimum",
      "per-year": "/yr",
      "error-minimum": "Please enter a value into minimum salary",
      "error-target": "Please enter a value into target salary",
      "error-both": "Please enter a value  into minimum and target salary"
    },
    "submit-go-ahead": {
      "label": "Can we go ahead and submit you to our clients for positions matching your preferences below?",
      "yes": "Yes, go ahead.",
      "no": "No, check with me first."
    },
    "success-page": {
      "heading": "THANK YOU FOR LETTING US KNOW MORE ABOUT YOUR CAREER GOALS!",
      "update-profile-desc": "If you’ve picked up a little more experience since we last heard from you, it’d be great to see an updated CV or portfolio.",
      "find-jobs-desc": "Find more job opportunities on the Aquent job board."
    },
    "workplace": {
      "label": "Work Location*",
      "on-site": "On-site",
      "remote": "Remote",
      "error": "Please select at least one of on-site or remote"
    }
  },
  "eeoc-form" : {
    "age-group": "Age Group",
    "armed-forces-service-medal-vet": "Armed Forces Service Medal Veteran",
    "authorized-to-work": "Are you authorized to work in the United States?",
    "contact-us": {
      "text_part1": "Aquent is an equal opportunity employer. We evaluate qualified applicants without regard to race, color, religion, sex, sexual orientation, gender identity, national origin, disability, veteran status, and other legally protected characteristics. Aquent is committed to working with and providing reasonable accommodation to individuals with disabilities. If, because of a medical condition or disability, you need a reasonable accommodation for any part of the employment process, please send an e-mail to ",
      "mailto": "compliance@aquent.com",
      "text_part2": " and let us know the nature of your request and your contact information. The “EEO is the Law” poster is available ",
      "link-text": "here."
    },
    "delete-modal": {
      "title": "EEO Information Deletion Request",
      "content": "For the deletion of equal employment opportunity data we ask candidates, former employees, and current employees to complete the webform <a href='https://privacyportal-cdn.onetrust.com/dsarwebform/05f24bb5-a0c4-43d4-966e-05606d5be9ca/def13fac-05a5-4eb5-9fd8-b2b56ff6cb97.html'> here</a> or call us at 1-877-727-8637. Before we can fulfill your request you must verify your identity.",
      "button-text": "Close"
    },
    "details": "details",
    "disability-header": "This list includes but is not limited to:",
    "disability-details": {
      "items": {
        "autism": "Autism",
        "bipolar disorder": "Bipolar disorder",
        "blindness": "Blindness",
        "cancer": "Cancer",
        "cerebral palsy": "Cerebral Palsy",
        "deafness": "Deafness",
        "diabetes": "Diabetes",
        "epilepsy": "Epilepsy",
        "hiv infection": "HIV infection",
        "intellectual disabilities": "Intellectual disabilities",
        "major depressive disorder": "Major depressive disorder",
        "mobility impairments requiring the use of a wheel chair": "Mobility impairments requiring the use of a wheel chair",
        "multiple sclerosis": "Multiple sclerosis",
        "muscular dystrophy": "Muscular dystrophy",
        "obsessive-compulsive disorder": "Obsessive-compulsive disorder",
        "partial or completely missing limbs": "Partial or completely missing limbs",
        "post-traumatic stress disorder": "Post-traumatic stress disorder",
        "schizophrenia": "Schizophrenia"
      }
    },
    "disability-no": "No",
    "disability-yes": "Yes",
    "do-not-wish-to-answer": "I do not wish to answer",
    "error": "{{fieldName}} is a required field.  Select “I do not wish to answer” if you do not want to disclose this information.",
    "error-immigration": "Immigration and employment authorization information is required. Please select an answer.",
    "ethnicity": "Ethnicity",
    "ethnicity_other": "Other",
    "ethnicity-details": {
      "white": "White (not Hispanic or Latino) – A person having origins in any of the original peoples of Europe, North Africa, or the Middle East.",
      "black": "Black or African American (not Hispanic or Latino) – A person having origins in any of the black racial groups of Africa.",
      "hispanic": "Hispanic or Latino – A person of Mexican, Puerto Rican, Cuban, Central or South American, or other Spanish culture or origin, regardless of race.",
      "asian": "Asian (not Hispanic or Latino) – A person having origins in any of the original peoples of the Far East, Southeast Asian, or the Indian subcontinent including for example, Cambodia, China, India, Japan, Korea, Malaysia, Pakistan, the Philippine Islands, Thailand, and Vietnam.",
      "american-indian": "American Indian/Alaskan Native (not Hispanic or Latino) – A person having origins in any of the original peoples of North America and South America (including Central America), and who maintains tribal affiliation or community attachment.",
      "native-hawaiian": "Native Hawaiian or Other Pacific Islander (not Hispanic or Latino) – A person having origins in any of the original peoples of Hawaii, Guam, Samoa, or other Pacific Islands.",
      "two-plus-races": "Two or More Races (not Hispanic or Latino) – All persons who identify with more than one of the above six races."
    },
    "equal-opportunity-header": "EQUAL EMPLOYMENT OPPORTUNITY INFORMATION",
    "equal-opportunity-subtext": "Providing this information is strictly voluntary. The law prohibits employers from taking an adverse action against you because you choose not to provide this information.",
    "gender": "Gender Identity",
    "gender_other": "Other",
    "immigration-header": "IMMIGRATION AND EMPLOYMENT AUTHORIZATION INFORMATION",
    "immigration-subtext": "Lorem ipsum dolor sit amet, consectetur adipiscing elitctetur adipiscing elitctetur adipiscing elit.",
    "fostering-a-diverse": "We Are Committed to Fostering a Diverse and Inclusive Community of Talent",
    "fostering-a-diverse-subtext": " Please update your equal opportunity employment data below.",
    "lgbtq": "Do you identify as a member of the LGBTQIA+ community?",
    "lgbtq-details": {
      "details": "LGBTQIA+ stands for lesbian, gay, bisexual, transgender, and queer or questioning, with the + referring to a wider variety of gender, romantic, and sexual identities not limited to those spelled out in the acronym."
    },
    "neurodivergent": "Do you identify as Neurodivergent?",
    "neurodivergent-details": {
      "details1": "Neurodivergent means having a brain that functions differently in ways that interpret and work with information.",
      "details2": "Some examples include but are not limited to ADHD, autism, dyslexia, dyscalculia."
    },
    "newly-separated-vet": "Recently Separated Veteran",
    "not-a-vet": "I am not a protected veteran",
    "other-protected-vet": "I am a protected veteran, but I choose not to self-identify the classifications to which I belong",
    "redeployme-message-one-more-thing": "One more thing before you go!",
    "redeployme-message-please-consider": "Please consider filling out Aquent's Equal Employment Opportunity Form.",
    "require-sponsorship": "Do you now, or will you at any point in the future, require immigration related sponsorship?",
    "special-disabled-vet": "Disabled Veteran",
    "self-identification-disability": "Do you identify as differently-abled?",
    "success-find-jobs": "Find Jobs",
    "success-find-jobs-info": "Find other job opportunities",
    "success-header": "THANK YOU FOR SHARING YOUR DIVERSITY AND INCLUSION DATA",
    "success-learn-more": "Learn More",
    "success-learn-more-info": "Learn more about our diversity and inclusion initiatives",
    "success-update-profile": "Update Profile",
    "success-update-profile-info": "Update your Aquent profile",
    "thanks": "{{name}}, thank you for sharing your equal employment information!",
    "using-data": {
      "header": "HOW WE’RE USING THIS DATA",
      "subtext": "Aquent is collecting this data in support of our diversity and inclusion efforts. We will use this data to evaluate our ability to recruit diverse candidates and to help our clients evaluate their hiring process. While you have the option not to answer the following questions, we value any information you are comfortable sharing.\n\nAll candidates submitted to clients are submitted based on how well their skills and experience meet the job requirements. Clients may be provided reporting of aggregated data to help them understand the composition of the candidate pools submitted to them by Aquent, and to assist clients to evaluate their hiring process. Personally identifiable demographic data is not shared with them.\n\nAccess to demographic data is limited to only those with a need to access for the above described purpose. Demographic data will not be seen by anyone involved in the selection process.\n\nBy completing this form you confirm your consent to our processing of this data as described in this notice.  You may withdraw your consent by contacting <a id='privacyEmail' href='mailto:privacy@aquent.com'>privacy@aquent.com</a>, and you may update your information in your MyAquent Talent account.  Your information will be treated as strictly confidential and handled in compliance with <a id='privacyLink' target='_blank' href='https://aquent.com/privacy-policy/'>Aquent's Privacy Policy</a> and the General Data Protection Regulations (GDPR) 2018."
    },
    "veteran-details": {
      "disabled-vet": "Disabled Veteran– means (1) A veteran of the U.S. military, ground, naval or air service who is entitled to compensation (or who but for the receipt of military retired pay would be entitled to compensation) under laws administered by the Secretary of Veterans Affairs, or (2) A person who was discharged or released from active duty because of a service-connected disability.",
      "medal-veteran": "Armed Forces Service Medal Veteran– means any veteran who, while serving on active duty in the U.S. military, ground, naval or air service, participated in a United States military operation for which an Armed Forces service medal was awarded pursuant to Executive Order 12985 (61 FR 1209, 3 CFR, 1996 Comp., p. 159).",
      "separated-vet": "Recently Separated Veteran– means a veteran during the three-year period beginning on the date of such veteran’s discharge or release from active duty in the U.S. military, ground, naval or air service.",
      "wartime-vet": "Active Duty Wartime or Campaign Badge Veteran – means a veteran who served on active duty in the U.S. military, ground, naval or air service during a war or in a campaign or expedition for which a campaign badge has been authorized under the laws administered by the Department of Defense."
    },
    "veteran-status": "Veteran Status",
    "vietnam-vet": "Active Duty Wartime Or Campaign Badge Veteran"
  },
  "footer": {
    "application-support": "Application Accommodation Support",
    "copyright-aq": "© {{year}} Aquent",
    "privacy-policy": "Privacy Policy",
    "questions-email": "questions@aquent.com"
  },
  "web-style-top-bar": {
    "preferences-confirmed": "Confirm Preferences",
    "preferences-edit": "Edit Preferences"
  },
  "redeploy": {
    "preferences-edit-header": "Edit your job preferences",
    "take-a-moment": "Take a moment to edit your preferences to ensure we're representing you accurately.",
    "phone": "Phone",
    "location": "Location",
    "available-to-start": "Available to start",
    "weeks-notice": "Weeks notice",
    "employment-type-label": "Work Type",
    "workplace-label": "Work Location",
    "hourly-rate-label": "Hourly Rate",
    "salary-label": "Yearly Salary",
    "permission-to-submit": "Aquent has permission to submit you to clients that match these preferences?",
    "resume-header": "Resume",
    "current-resume": "Current resume ",
    "uploaded-on": "uploaded on ",
    "upload-resume": "Upload New Resume",
    "cancel": "Cancel"
  },
  "thank-you": "Thank you. You're all set!",
  "no": "No",
  "submit": "Submit",
  "delete": "Delete",
  "yes": "Yes",
  "gather": {
    "complete-profile": "Complete your profile",
    "eeoc-form-title": "Equal Opportunity",
    "enter-url": "Enter a URL",
    "error": {
      "general": "Hmm...we're having trouble with this URL. Please make sure it's correct before continuing.",
      "inaccessible": "Hmm...we're having trouble accessing your site. Please make sure your URL is correct before continuing.",
      "not-found": "Hmm...we're having trouble finding your site. Please make sure your URL is correct before continuing."
    },
    "interested": {
      "label": "INTERESTED",
      "title": "Update Availability",
      "confirm": {
        "title": "Thank you!"
      },
      "compensation": "What's your ideal compensation?",
      "available-to-start": "When would you be available to start?"
    },
    "interest": {
      "title": "Role Interest"
    },
    "notice-text": "How much notice?",
    "immediately": "Immediately",
    "with-notice": "With notice",
    "two-weeks-notice": "Two Weeks Notice",
    "specific-date": "On A Specific Date",
    "thank-you": "Thank you!",
    "thank-you-text": "Your interest and availability have been sent to the agent working on this position. They will review it and get in touch if you are a fit.",
    "second-time": {
      "thank-you-text": "We received your response on {{responseDate}}. If you have any questions, please contact {{agentName}} at {{agentEmail}}."
    },
    "update-profile": "Update profile",
    "update-profile-text": "New resume or portfolio? Update your information so agents and clients are seeing your best work",
    "update-my-profile": "Update My Profile",
    "complete-review-text": "Request reviews from past colleagues to showcase your strengths, skills and potential.",
    "add-reviews": "ADD REVIEWS",
    "track-your-status": "Track your status",
    "track-status-text": "See your status for roles that you are considering. We will still reach out to you with urgent updates.",
    "track-my-status": "Track My Status",
    "see-more-jobs": "See more jobs",
    "see-more-jobs-text": "We are working on new roles every day! Check out more postings that might interest you and show your interest.",
    "visit-job-center": "Visit Job Center",
    "description": "DESCRIPTION",
    "showcase": "Please make sure we are showcasing your best work:",
    "starting": "Starting",
    "full-time": "FULL-TIME ",
    "part-time": "PART-TIME ",
    "jobId": "Job ID #",
    "agent": "Agent: ",
    "availability": {
      "response-date": "MMM dd, yyyy",
      "error": "We are having some trouble saving your availability. Please try again."
    },
    "client-description": "CLIENT DESCRIPTION",
    "other-requirements": "OTHER REQUIREMENTS",
    "not-interested": {
      "actively-looking": "Actively Looking",
      "available-to-start": "When are you available to start?",
      "be-in-touch": "Great! We'll be in touch.",
      "check-in-again": "When should we check in again?",
      "hear-from-us": "Would you like to hear from us if we find a great opportunity?",
      "job-search": "Where are you in your job search?",
      "label": "No Thanks",
      "title": "Not Interested",
      "check-back-few-months": "Check back in a few months",
      "check-back-on": "Check back on a specific date",
      "company-or-industry": "Company or Industry",
      "choose-a-date": "Choose a date",
      "pay-rate": "Pay rate",
      "location": "Location",
      "skill-set": "Mismatched skill set",
      "other": "Other",
      "tell-us-more": "Tell us more:",
      "tell-us-more-interested": "Additional notes for us?",
      "primary-reason": "Please let us know why this wasn't a match (choose all that apply):",
      "send-feedback": "Send Feedback",
      "submit": "Submit",
      "thank-you-text": "We have received your feedback and will use it to improve our notifications.",
      "refer-friend": "Refer a friend",
      "learn-more": "Learn More",
      "confirm": {
        "title": "Thank you!"
      },
      "reason": {
        "skill-set-mismatch":"Mismatched Skill Set",
        "level-mismatch":"Mismatched Level",
        "pay-rate":"Pay Rate",
        "location":"Location",
        "industry":"Industry",
        "other":"Other"
      },
      "refer-text": "Know someone who'd be great for this? Let us know! See details on how our cash bonuses work for Talent Rewards.",
      "still-interested": "Are you still interested in hearing about other opportunities?",
      "still-interested-confirmation": "When would you be available to start a new opportunity?",
      "thank-you": "Thanks for your response",
      "may-we-check-in": "Let us know when we can check in again.",
      "not-currently-looking": "Not Currently Looking",
      "open-to-opportunities": "Open To Good Opportunities",
      "other-job-postings": "There are plenty of other jobs available on our jobs website. Come take a look!"
    },
    "back-to-posting": "< Back to posting",
    "not-interested-text": "Please tell us why this role didn't interest you so we can improve our notifications.",
    "yes": "Yes",
    "no": "No",
    "job-closed": {
      "sorry": "We're sorry",
      "sorry-text": "Thank you for your response, but it turns out this job is no longer available."
    },
    "invalid-id": {
      "text": "We’re sorry, but we can't seem to find the page you were looking for.",
      "oops": "Oops!"
    },
    "already-a-talent": {
      "text": "It appears you are already working with us on this opportunity. Please reach out to your agent with any questions:",
      "oops": "Oops!"
    },
    "greetings": "Hi ",
    "header1": "Here is a new role we are working on that matches your ",
    "header2": " on file. Please review the details and let us know if you are interested below.",
    "preferences": "preferences",
    "footer-address": "Suite 11.02, Level 11, 1 Castlereagh Street, Sydney, NSW 2000, Australia",
    "privacy-policy": "This is not a marketing text message. The purpose of this message is to communicate important information regarding your business with Aquent.",
    "privacy": "Privacy",
    "titles": {
      "role-interest": "Role Interest"
    }
  },
  "double-opt-in": {
    "confirm": {
      "header": "Thank you and welcome!",
      "sub-text": "You are successfully subscribed to Aquent communications."
    }
  },
  "pre-interview-questions": {
    "category": {
      "authorization": "authorization",
      "location": "location",
      "relocation": "relocation",
      "travel": "travel"
    },
    "question": {
      "0": "Are you authorized to work in the US?",
      "1": "Do you require a work visa sponsorship now or in the future?",
      "2": "Are you located in the US?",
      "3": "Are you able to work on-site at the client location?",
      "4": "How many days per week are you able to work on site?",
      "5": "Are you willing to relocate?",
      "6": "Are you willing to relocate at your own expense?",
      "7": "How much time are you willing to travel for this position?"
    },
    "header": "Pre-interview Questions",
    "header-description": "This is an optional feature to ask candidates additional questions in the job application and Gather process. You have the option to select up to 3 optional questions.",
    "no-questions-selected-message": "You currently do not have any questions selected. Select some or update this message 🙈",
    "answer-options": "Answer options",
    "answer-option-yes": "Yes",
    "answer-option-no": "No",
    "answer-header-description": "Please answer the following questions to the best of your ability. Questions are optional.",
    "textarea-max-characters": "(character limit: 500)"
  }
}
